<div class="dashboard-container container-fluid px-0">
  <div class="row g-0 vh-100 overflow-hidden">
    <div
      v-if="!is_mobile"
      class="col-auto sidebar-wrapper d-flex flex-column flex-shrink-0 vh-100 overflow-hidden"
      :class="{ 'sidebar-collapsed': sidebar_collapsed }"
    >
      <MiningSidebar
        v-if="sidebar_sector === 'mining'"
        :active_item="sidebar_mining_item"
        :can_view_portfolio="sidebar_can_view_portfolio"
        @go-overview="open_sidebar_portfolio"
        @mining-menu-selected="open_sidebar_mining_menu"
        @select-sector="open_sidebar_sector"
      />
      <PropertySidebar
        v-else-if="sidebar_active_property"
        :active_property="sidebar_active_property"
        :properties="sidebar_tiles"
        :active_item="sidebar_active_item"
        :can_view_portfolio="sidebar_can_view_portfolio"
        @switch-property="open_sidebar_property"
        @go-back="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
        @select-sector="open_sidebar_sector"
      />
      <PortfolioSidebar
        v-else
        :tiles="sidebar_tiles"
        @tile-clicked="open_sidebar_property"
        @global-menu-selected="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
        @global-selected="open_sidebar_portfolio"
        @select-sector="open_sidebar_sector"
      />
    </div>

    <div v-if="is_mobile && mobile_sidebar_open" class="mobile-sidebar-overlay" @click.self="mobile_sidebar_open = false">
      <div class="mobile-sidebar-panel h-100 overflow-hidden">
        <MiningSidebar
          v-if="sidebar_sector === 'mining'"
          :active_item="sidebar_mining_item"
          :can_view_portfolio="sidebar_can_view_portfolio"
          @go-overview="open_sidebar_portfolio"
          @mining-menu-selected="open_sidebar_mining_menu"
          @select-sector="open_sidebar_sector"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center p-0" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </MiningSidebar>
        <PropertySidebar
          v-else-if="sidebar_active_property"
          :active_property="sidebar_active_property"
          :properties="sidebar_tiles"
          :active_item="sidebar_active_item"
          :can_view_portfolio="sidebar_can_view_portfolio"
          @switch-property="open_sidebar_property"
          @go-back="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
          @select-sector="open_sidebar_sector"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center p-0" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PropertySidebar>
        <PortfolioSidebar
          v-else
          :tiles="sidebar_tiles"
          @tile-clicked="open_sidebar_property"
          @global-menu-selected="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
          @global-selected="open_sidebar_portfolio"
          @select-sector="open_sidebar_sector"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center p-0" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PortfolioSidebar>
      </div>
    </div>

    <button v-if="!is_mobile" class="sidebar-collapse-btn btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center p-0" @click="sidebar_collapsed = !sidebar_collapsed" aria-label="Toggle sidebar">
      <i :class="sidebar_collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
    </button>

    <div class="col vh-100 d-flex flex-column overflow-hidden no-scrollbar">
    <HeaderSection
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @open-assistant="show_assistant = true"
        @toggle-mobile-sidebar="toggle_mobile_sidebar"
    />

<div class="container-fluid p-0 settings-page flex-grow-1 min-h-0">

    <div v-if="load_error || save_success" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
        <div v-if="load_error" class="toast show align-items-center text-dark border-0 shadow-lg auth-toast auth-toast-error" role="alert">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
                    <i class="bi bi-exclamation-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ load_error }}</div>
                <button type="button" class="btn-close ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_load_error"></button>
            </div>
        </div>

        <div v-if="save_success" class="toast show align-items-center text-dark border-0 shadow-lg auth-toast auth-toast-success" role="status">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
                    <i class="bi bi-check2-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ save_success }}</div>
                <button type="button" class="btn-close ms-auto flex-shrink-0" aria-label="Dismiss success message" @click="clear_save_success"></button>
            </div>
        </div>
    </div>

    <section class="container-fluid px-4 py-4">
        <div class="mb-4 d-flex flex-column flex-lg-row justify-content-between align-items-lg-end gap-3">
            <div>
                <p class="aic-page-eyebrow text-uppercase fw-bold mb-2">Workspace configuration</p>
                <h3 class="fw-bold mb-2">Tariff Assignments</h3>
                <p class="text-muted mb-0">
                    <span v-if="selected_context_property">
                        Showing records linked to {{ selected_context_property.name }}.
                    </span>
                    <span v-else>
                        {{ is_service_provider_tab
                            ? "Manage the data and specialist service providers used by each property dashboard."
                            : "Manage property tariff assignments and open tariff books to review or update rates." }}
                    </span>
                </p>
            </div>

            <div v-if="!is_service_provider_tab" class="d-flex flex-wrap align-items-center gap-2">
                <span class="badge rounded-pill settings-soft-badge">{{ total_tariffs }} properties</span>
                <span class="badge rounded-pill settings-soft-badge settings-soft-badge-success">{{ assigned_visible_tariffs_count }} assigned</span>
                <span class="badge rounded-pill settings-soft-badge settings-soft-badge-info">{{ visible_tariff_books.length }} tariff books</span>
            </div>
        </div>

        <SnackbarMessage :error-message="load_error" @dismiss-error="load_error = ''" />

        <div class="settings-tab-strip d-inline-flex align-items-center mb-4">
            <button
                v-for="tab in settings_tabs"
                :key="tab.id"
                type="button"
                class="btn rounded-0 border-0 px-4 py-3 fw-bold text-sm settings-tab-button"
                :class="active_settings_tab === tab.id ? 'settings-tab-button-active' : 'settings-tab-button-inactive'"
                @click="set_active_settings_tab(tab.id)"
            >
                {{ tab.title }}
            </button>
        </div>

        <div v-if="is_loading" class="glass-card border p-4 rounded-4 text-muted">
            <div class="d-flex align-items-center gap-3">
                <div class="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></div>
                <div>
                    <p class="fw-semibold mb-1">Loading tariff settings</p>
                    <p class="text-muted text-xs mb-0">We are pulling properties, tariff books, and assignments for this workspace.</p>
                </div>
            </div>
        </div>

        <div v-else>
            <SettingsPropertyTab
                v-if="active_settings_tab === 'property'"
                :tariff_rows="visible_tariff_rows"
                :get_assignment_date_range="get_assignment_date_range"
                @add-tariff="open_add_tariff_modal"
                @edit-assignment="edit_tariff"
            />

            <SettingsTariffBookTab
                v-else-if="active_settings_tab === 'tariff_book'"
                :tariff_books="visible_tariff_books"
                :tariffs="visible_tariffs"
                :tariff_rates="visible_tariff_rates"
                :format_date="format_date"
                @view-rates="open_tariff_book_rates_modal"
            />

            <SettingsServiceProviderTab
                v-else
                :properties="visible_properties"
                :active_property_id="active_settings_property_id"
            />
        </div>
    </section>

    <SettingsAssignmentModal
        :is_open="show_add_tariff_modal"
        :is_saving="is_saving"
        :form_error="form_error"
        :selected_assignment_id="selected_assignment_id"
        :active_properties="active_properties"
        :municipalities="municipalities"
        :tariff_books="tariff_books"
        :tariffs="tariffs"
        :tariff_form="new_tariff"
        :is_property_locked="is_property_locked"
        @close="close_add_tariff_modal"
        @submit="add_tariff"
        @update:tariffForm="update_new_tariff_form"
    />

    <TariffBookRatesModal
        :is_open="show_tariff_rates_modal"
        :tariff_book="selected_tariff_book"
        :context="selected_tariff_context"
        :initial_tab="selected_tariff_rates_tab"
        @close="close_tariff_rates_modal"
        @updated="handle_tariff_rates_updated"
    />

    <BolideAssistant :is_open="show_assistant" @close-assistant="show_assistant = false" />
</div>
    </div>
  </div>
</div>
